import { cn } from '~/shared/lib/cn'
import { LocalIcon } from '~/shared/ui'

export function ConfidenceBadge({
  confidencePercentage,
  label,
}: {
  confidencePercentage: number
  /** Overrides the default "High" / "Mid" / "Low" text, keeping the icon and colors. */
  label?: string
}) {
  return (
    <div
      className={cn(
        'flex h-7 items-center gap-1 rounded-sm border px-2 text-sm leading-[18px] tracking-[0.15px]',
        {
          'border-chip-status-success-content text-chip-status-success-content':
            confidencePercentage >= 75,
          'border-alert-warning-message text-alert-warning-message':
            confidencePercentage >= 50 && confidencePercentage < 75,
          'border-alert-error-message text-alert-error-message': confidencePercentage < 50,
        },
      )}
    >
      {confidencePercentage >= 75 ? (
        <>
          <LocalIcon name="opti" />
          <span>{label ?? 'High'}</span>
        </>
      ) : confidencePercentage >= 50 ? (
        <>
          <LocalIcon name="optiNeutral" />
          <span>{label ?? 'Mid'}</span>
        </>
      ) : (
        <>
          <LocalIcon name="optiSad" />
          <span>{label ?? 'Low'}</span>
        </>
      )}
    </div>
  )
}
